import styled from 'styled-components';
import { Button } from '@hotelplan/components.common.buttons';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';

export const OrlOfferDescription = styled.div<{
  hasAlternativeFlights?: boolean;
}>(({ hasAlternativeFlights }) =>
  sx2CssThemeFn({
    display: ['flex', 'grid'],
    flexDirection: ['column', 'row'],
    alignItems: [null, 'start'],
    gridTemplateColumns: [
      null,
      hasAlternativeFlights ? '15% 26% 24% 18% 18%' : '27% 23% 30% 20%',
    ],
    backgroundColor: ['#f9f9f9', 'unset'],
    p: ['10px'],
    borderTop: [null, '1px solid #c2c2c2'],
    borderBottom: '1px solid #c2c2c2',
    borderLeft: [null, '1px solid #c2c2c2'],
    mb: [null, '-1px'],
    '.date': {
      display: 'flex',
      flexDirection: [null, 'column'],
      flexShrink: [null, '0'],
      fontSize: '14px',
      color: 'textGray',
      fontWeight: 'bold',
      mb: ['2px', 0],
      '.delimiter': {
        px: 1,
      },
      '.value': {
        textTransform: 'capitalize',
      },
    },
    '.departure-city': {
      fontSize: '14px',
      color: 'textGray',
      fontWeight: [null, 'bold'],
      mb: [3, 0],
      flexShrink: [null, '0'],
    },
    '.room, .transfer': {
      display: 'grid',
      alignItems: 'start',
      flexDirection: [null, 'column'],
      gridTemplateColumns: 'auto 1fr',
      gap: ['8px 0', 1],
      mb: [1, 0],
      '.icon-wrapper': {
        mr: 1,
      },
    },
    '.transfer': {
      display: ['grid', 'flex'],
      flexDirection: [null, 'row'],
      gap: ['8px 0', 0],
      fontSize: ['12px', '11px'],
      fontWeight: [null, 'normal'],
      color: [null, '#717171'],
      pt: [null, 1],
      '.text': {
        fontSize: ['12px', '11px'],
        fontWeight: [null, 'normal'],
        color: [null, '#717171'],
        whiteSpace: `nowrap`,
      },
      '& .icon': {
        color: [null, '#999'],
      },
    },
    '.text': {
      fontSize: '14px',
      color: 'textGray',
      fontWeight: [null, 'bold'],
    },
    '.traveller-title': {
      color: '#999',
      fontSize: ['15px', 1],
    },
    '.bottom-card': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'end',
      alignSelf: [null, 'center'],
      '.button': {
        variant: 'buttons.allOffers',
      },
      '.price-title': {
        fontSize: ['14px', 1],
        color: ['textGray', '#000'],
        fontWeight: 'bold',
        mb: [2, 0],
      },
    },
    '.flight-button-open': {
      fontSize: 0,
      color: 'primary',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    '.b2b-details': {
      fontWeight: 'normal',
      fontSize: 0,
      mt: 1,
    },
    '.room-wrap': {
      '&:not(:first-child)': {
        pt: [null, 1],
        borderTop: [null, '1px solid #666'],
      },
      mr: [null, 2],
      pb: [null, 1],
    },
    '.room': {
      gridTemplateColumns: '1fr',
      '.type': {
        mb: 1,
      },
    },
  })
);

export const OrlOfferFlight = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    flexDirection: 'column',
    borderLeft: [null, '1px solid #c2c2c2'],
    backgroundColor: 'white',
    '.flight-toggle-button': {
      color: 'primary',
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      borderBottom: ['1px solid #c2c2c2', 'none'],
      '&.open': {
        color: 'secondary',
        '.chevron': {
          transform: 'rotate(-90deg)',
        },
      },
      '.chevron': {
        ml: 'auto',
        transform: 'rotate(90deg)',
      },
      '.icon:first-child': {
        mr: 2,
        transform: 'rotate(-35deg)',
      },
    },
    '.flight-bottom': {
      borderTop: [null, '1px solid #c2c2c2'],
      position: [null, 'relative'],
      '.flight-item-header': {
        display: 'grid',
        gridTemplateColumns: ['repeat(3, 1fr)', '15% 26% 23% 18% 18%'],
        alignItems: 'start',
        padding: ['10px', '10px 0'],
        color: '#999',
        fontFamily: '"Helvetica Neue",sans-serif',
        fontSize: [1, 2],
        borderBottom: ['1px solid #c2c2c2', 'unset'],
        '.date': {
          fontSize: '14px',
          fontFamily: '"Arial",sans-serif',
          fontWeight: 'bold',
          textTransform: 'capitalize',
        },
        '.title': {
          color: 'secondary',
          fontSize: 2,
          whiteSpace: 'nowrap',
        },
        '.subtitle': {
          color: 'textGray',
          fontSize: '14px',
          fontFamily: '"Arial",sans-serif',
          whiteSpace: 'nowrap',
          fontWeight: 'bold',
        },
        '.column': {
          borderBottom: [null, '1px solid #c2c2c2'],
          height: '100%',
          pb: [null, 2],
          '&.desktop': {
            borderColor: 'transparent',
            pl: '10px',
          },
        },
      },
    },
  })
);

export const ModalCloseButton = styled(Button).attrs({
  variant: 'iconBtn',
  icon: { name: 'close' },
  'data-id': `close`,
})(
  sx2CssThemeFn({
    position: 'absolute',
    top: '8px',
    right: '8px',
    backgroundColor: 'inherit',
    '.icon': {
      variant: 'icons.sm',
    },
  })
);
